<template>
  <v-card class="pa-2" flat color="#f0f0f0" style="border-radius: 0px">
    <v-container v-if="aData">
      <v-card class="cshadow">
        <v-row>
          <v-col cols="2" class="pa-1 pl-4 pb-0">
            <img
              alt=""
              :src="getImgPath(aData.picHeadShot)"
              style="border-radius: 90px; height: 90px"
            />
          </v-col>
          <v-col cols="5" class="pa-1">
            <div style="font-size: 1.2rem; font-weight: 600">
              <div style="font-size: 1.4rem; color: #4b23fa">
                {{ aData.app_id }}
              </div>
              {{ aData.fName }} {{ aData.lName }}
            </div>
          </v-col>
          <v-col cols="5" class="pa-1">
            <div style="font-size: 1.2rem; font-weight: 600">
              <div style="color: #808080; font-size: 1rem">App Status</div>
              {{ aData.status_named }}
            </div>
            {{ aData.reason_name }}
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col cols="8">
          <v-card class="cshadow">
            <div class="cardHeader">Personal Details</div>
            <div class="pa-3 pt-0">
              <v-row>
                <v-col cols="6">
                  <FieldValue
                    Text="First Name"
                    :Value="aData.fName"
                  ></FieldValue>
                </v-col>
                <v-col cols="6">
                  <FieldValue
                    Text="Last Name"
                    :Value="aData.lName"
                  ></FieldValue>
                </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-row>
                <v-col cols="6">
                  <FieldValue Text="Email" :Value="aData.email"></FieldValue>
                </v-col>
                <v-col cols="6">
                  <FieldValue
                    Text="Mobile"
                    :Value="aData.ext + ' - ' + aData.mobile"
                  ></FieldValue>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <v-card class="cshadow mt-3">
            <div class="cardHeader">Identification</div>
            <div class="pa-3 pt-0">
              <v-row>
                <v-col cols="6">
                  <FieldValue
                    Text="ID Proof Type"
                    :Value="aData.idProofType"
                  ></FieldValue>
                </v-col>
                <v-col cols="6">
                  <FieldValue
                    Text="ID Proof Number"
                    :Value="aData.idProofNumber"
                  ></FieldValue>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <v-card class="cshadow mt-3">
            <div class="cardHeader">Accreditation Details</div>
            <div class="pa-3 pt-0">
              <v-row>
                <v-col cols="4">
                  <FieldValue
                    Text="Category"
                    :Value="aData.companytype_name"
                  ></FieldValue>
                </v-col>
                <v-col cols="4">
                  <FieldValue
                    Text="Job Type"
                    :Value="aData.jobtype_name"
                  ></FieldValue>
                </v-col>
                <v-col cols="4">
                  <FieldValue
                    Text="Access"
                    :Value="aData.print_text"
                  ></FieldValue>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>

        <v-col cols="4">
          <v-card
            class="cshadow"
            v-if="this.aData.picIdFront != '' && this.aData.picIdFront != null"
          >
            <div class="cardHeader">ID Proof - Front</div>
            <div class="pa-3">
              <viewer
                :images="[this.$apiPhotoPath + '/' + this.aData.picIdFront]"
              >
                <img
                  :src="this.$apiPhotoPath + '/' + this.aData.picIdFront"
                  class="imgId"
                  width="100%"
                />
              </viewer>
            </div>
            <br />
            <div
              v-if="this.aData.picIdBack != '' && this.aData.picIdBack != null"
            >
              <div class="cardHeader">ID Proof - Back</div>
              <div class="pa-3">
                <viewer
                  :images="[this.$apiPhotoPath + '/' + this.aData.picIdBack]"
                >
                  <img
                    :src="this.$apiPhotoPath + '/' + this.aData.picIdBack"
                    class="imgId"
                    width="100%"
                  />
                </viewer>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    
    <v-overlay :value="loading" style="z-index: 9999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import "viewerjs/dist/viewer.css";
import FieldValue from "../application/FieldValue";

export default {
  name: "ViewAppliation",
  components: { FieldValue },
  props: ["aData"],
  data: () => ({
    loading: false,
    modPdf: false,
  }),
  mounted() {
    console.log(this.aData);
  },
  methods: {
    getImgPath(fileName) {
      if (fileName == "" || fileName == null) {
        return "images/nophoto.png";
      } else {
        return this.$apiPhotoPath + "/" + fileName;
      }
    },
  },
};
</script>

<style scoped>
.imgId {
  border-radius: 7px;
  box-shadow: 0 0 10px #ccc;
  cursor: pointer;
}
.cshadow{
  box-shadow:0 0 15px #e7e7e7 !important;
}
</style>